export const generateCommonTrackingIds = (featureName: string) => ({
  chartsView: `${featureName}-charts-view-tab`,
  clearFilters: `${featureName}-clear-filters`,
  downloadMain: `${featureName}-download-main`,
  filtersOpen: `${featureName}-filters-open`,
  helpVideo: `${featureName}-help-video`,
  tableView: `${featureName}-table-view-tab`,
});
